import { render, staticRenderFns } from "./QuizStep.vue?vue&type=template&id=521cb904&"
import script from "./QuizStep.vue?vue&type=script&lang=js&"
export * from "./QuizStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports